import React, { Component } from "react";
import { connect } from "react-redux";

import { Card, Table, Tooltip, Button, Tag, Select, Input, Alert } from "antd";
import {
  getNowAcademicYear,
  getNowAcademicSemester,
} from "../../utils/dateUtil";
import { usrRole } from "../../utils/dataUtil";
import {
  req_page_tms_teachingMaterial,
  req_downloadfile_tms_teachingMaterial,
} from "../../api";
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { formateDateDbT } from "../../utils/dateUtil";
class MaterialStatusList extends Component {
  state = {
    loading: false,
    userLevel: "NORMAL",
    item: {},
    // 分頁參數
    items: [],
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    nowAcademicYear: getNowAcademicYear(new Date()),
    nowAcademicSemester: getNowAcademicSemester(new Date()),
    domnloadFile: "",
    isShowModal: false,
    lastupdatetime: "",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      nowAcademicYear,
      nowAcademicSemester,
    } = this.state;
    const { token, role, userCode } = this.props.user;

    const userLevel = usrRole(role);
    this.setState({ loading: true, userLevel: userLevel });
    const result = await req_page_tms_teachingMaterial(
      userLevel,
      userCode,
      nowAcademicYear,
      nowAcademicSemester,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    this.setState({ loading: false });
    //console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      const lastupdatetime = result.data[0].recordCreateDateTime;
      this.setState({ items, pagination, lastupdatetime });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_downloadfile_items = async () => {
    const { userLevel, searchField, searchValue, filterStatus } = this.state;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_tms_teachingMaterial(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "學年/期",
        width: 20,
        responsive: ["md"],
        render: (item) => {
          const { academicYear, academicSemester } = item;
          return (
            <div className="text-center">
              <span>
                {academicYear}/{academicSemester}
              </span>
            </div>
          );
        },
      },
      {
        title: "課程名稱",
        width: 40,
        render: (item) => {
          const { caption, insideCourseCode } = item;
          return (
            <div>
              <span style={{ fontSize: "1.2em" }}>{caption}</span>
              <br></br>
              <span>
                <Tag>開課序號：{insideCourseCode}</Tag>
              </span>
            </div>
          );
        },
      },
      {
        title: "科系",
        width: 30,
        responsive: ["md"],
        render: (item) => {
          const { courseDepartment, timeType } = item;
          return (
            <div>
              <span style={{ fontSize: "1.2em" }}>{courseDepartment}</span>
              <br></br>
              <span>
                <Tag color={timeType === "專任" ? "orange" : "geekblue"}>
                  {timeType}
                </Tag>
              </span>
            </div>
          );
        },
      },
      {
        title: "姓名",
        width: 30,
        render: (item) => {
          const { teacherCode, teacherName } = item;
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.2em" }}>{teacherName}</span>
              <br></br>
              <span>
                <Tag color="purple">{teacherCode}</Tag>
              </span>
            </div>
          );
        },
      },
      {
        title: "聯絡方式",
        width: 45,
        render: (item) => {
          const { phone, email, telephone } = item;
          return (
            <div>
              <a
                href={"mailto:" + email}
                target="_blank"
                rel="noreferrer"
                className="btn btn-outline-dark btn-sm btn-block text-left"
              >
                <i className="fas fa-envelope"></i>：{email}
              </a>

              <a
                href={"tel:" + phone}
                target="_blank"
                rel="noreferrer"
                className="btn btn-outline-dark btn-sm btn-block text-left"
              >
                <i className="fas fa-mobile-alt"></i>：{phone}
              </a>

              <a
                href={"tel:" + telephone}
                target="_blank"
                rel="noreferrer"
                className="btn btn-outline-dark btn-sm btn-block text-left"
              >
                <i className="fas fa-phone-alt"></i>：{telephone}
              </a>
            </div>
          );
        },
      },
      {
        title: "狀況",
        width: 20,
        render: (item) => {
          const { hasMaterial } = item;
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}>
                {" "}
                {hasMaterial === "done" ? (
                  <>
                    <Tag color="#87d068">已上傳</Tag>
                  </>
                ) : (
                  <>
                    <Tag color="#f50">未上傳</Tag>
                  </>
                )}
              </span>
            </div>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    // if (filters) {
    //   const status = [...Object.values(filters).filter(Boolean)][0];
    //   if (status) {
    //     this.setState({ filterStatus: status }, () => {
    //       this.api_page_items(pagination.current);
    //     });
    //   } else {
    //     this.setState({ filterStatus: "" }, () => {
    //       this.api_page_items(pagination.current);
    //     });
    //   }
    // } else {
    this.api_page_items(pagination.current);
    //}
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      case "add":
        this.setState({ isAddModal: true });
        break;
      case "delete":
        // const { activityNid } = item
        // Modal.confirm({
        //     title: `您確定刪除此筆數據`,
        //     onOk: () => {
        //         this.api_delete_item(activityNid)
        //     }
        // })
        break;
      case "download":
        break;
      default:
    }
  };

  /////////////////////////////////////////////////////////////
  render() {
    const {
      loading,
      items,
      pagination,
      searchField,
      searchValue,
      filterStatus,
      lastupdatetime,
    } = this.state;
    const info =
      "註：每日排程統計，最近一次更新時間( " +
      formateDateDbT(lastupdatetime) +
      " )";
    const title = (
      <>
        <Select
          value={filterStatus}
          style={{ width: 120, backgroundColor: "LightCyan" }}
          onChange={(value) => this.setState({ filterStatus: value })}
        >
          <Select.Option value="">不分狀態</Select.Option>
          <Select.Option value="UNDONE">未上傳</Select.Option>
          <Select.Option value="DONE">已上傳</Select.Option>
        </Select>
        <Select
          value={searchField}
          style={{ width: 120, backgroundColor: "LightCyan" }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="teacherCode">老師職號</Select.Option>
          <Select.Option value="teacherName">老師名稱</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{
            width: 80,
            margin: "0 5px",
            backgroundColor: "LightYellow",
          }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        <Button type="primary" onClick={() => this.handle_data_download()}>
          <i className="fas fa-cloud-download-alt element-hidden"></i>
          <span style={{ marginLeft: "4px" }}> 下載</span>
        </Button>
        <div>
          <Alert message={info} type="error" />
        </div>
      </>
    );
    return (
      <Card>
        {title}
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="netSchoolCourseCode"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            onChange: this.handle_table_change,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(MaterialStatusList);
